module.exports = __webpack_public_path__ + "media/images/icons/outlined/dashboard-cb79f548eafefc0dfa02fbbc076751c8.svg";